import PercentageItem from '@op/components/Snippets/PercentageItem';
import RingRatioBubble from '@op/components/Snippets/RingRatioBubble';
import { getChartsShowCount } from '@op/utils';
import { DBO_V } from '@op/utils/format';
import moment from 'moment';
import React from 'react';
import { useIntl } from 'umi';

export default function QOQValue({
  item,
  valueKey,
  title,
  linkTime = {},
  isPercentage = false,
  progressVisible,
  showRatio = true,
}: {
  item: any;
  valueKey: string;
  title: string;
  isPercentage?: boolean;
  linkTime: {
    new?: string[];
    old?: string[];
  };
  progressVisible: boolean;
  showRatio?: boolean;
}) {
  const { formatMessage } = useIntl();

  let value = item[valueKey],
    percentage = item[valueKey + '_qoq'],
    barPercentage = item[valueKey + '_progress'],
    old_value = item['old_' + valueKey];

   
  if(value === 0 || old_value === 0){
    percentage = 0;
  }

  return (
    <div className={`${progressVisible ? 'is-percent' : 'is-no-percent'}`}>
      <div className="table-text-bg" style={{ width: barPercentage }}></div>

      <PercentageItem className="dbo-numtrends" percentage={percentage}>
        {(percentageElement: any) => (
          <>
            <span className="dbo-numtrends-num">
              {isPercentage
                ? DBO_V.ratio_min(value)
                : getChartsShowCount(value, 2, '-')}
            </span>
            {showRatio && (
              <RingRatioBubble
                oldTime={linkTime?.old || []}
                newTime={linkTime?.new || []}
                oldValue={old_value}
                newValue={value}
                title={formatMessage({ id: title })}
                formateDate={(key: moment.MomentInput) =>
                  !key ? '-' : moment(key).format('YYYY-MM-DD')
                }
                formateValue={(key: number) =>
                  isPercentage
                    ? DBO_V.ratio_min(key)
                    : getChartsShowCount(key, 2, '-')
                }
              >
                {percentageElement}
              </RingRatioBubble>
            )}
          </>
        )}
      </PercentageItem>
    </div>
  );
}
